import React from 'react';
import styled from 'styled-components';

type Colors = 'red' | 'green' | 'gray' | 'yellow';

const red = '232, 37, 27';
const green = '0, 206, 151';
const gray = '98, 98, 103';
const yellow = '234, 142, 66';

const indicatorColorFn = (props: { $indicatorColor: Colors }) =>
  props.$indicatorColor === 'gray'
    ? gray
    : props.$indicatorColor === 'red'
    ? red
    : props.$indicatorColor === 'yellow'
    ? yellow
    : green;

// const rotateRedAnimation = keyframes `
//   0% {
//     background: rgba(${red}, 0.3);
//     box-shadow: inset 0 0 10px 2px rgba(${red}, 0.5),
//       0 0 5px 2px rgba(${red}, 0.3);
//   }
//   100% {
//     background: rgba(${red}, 1);
//     box-shadow: inset 0 0 10px 2px rgba(${red}, 0.5),
//       0 0 15px 2px rgba(${red}, 1);
//   }
// `;
// const rotateGreenAnimation = keyframes `
//   0% {
//     background: rgba(${green}, 0.3);
//     box-shadow: inset 0 0 10px 2px rgba(${green}, 0.5),
//       0 0 5px 2px rgba(${green}, 0.3);
//   }
//   100% {
//     background: rgba(${green}, 1);
//     box-shadow: inset 0 0 10px 2px rgba(${green}, 0.5),
//       0 0 15px 2px rgba(${green}, 1);
//   }
// `;
// const rotateYellowAnimation = keyframes `
//   0% {
//     background: rgba(${yellow}, 0.3);
//     box-shadow: inset 0 0 10px 2px rgba(${yellow}, 0.5),
//       0 0 5px 2px rgba(${yellow}, 0.3);
//   }
//   100% {
//     background: rgba(${yellow}, 1);
//     box-shadow: inset 0 0 10px 2px rgba(${yellow}, 0.5),
//       0 0 15px 2px rgba(${yellow}, 1);
//   }
// `;

const Wrapper = styled.div<{ $indicatorColor: Colors; title?: string }>`
  width: 10px;
  height: 10px;
  border-radius: 100%;

  background: rgba(${indicatorColorFn}, 1);
  /* box-shadow: inset 0 0 10px 2px rgba($ {indicatorColorFn}, 0.5),
    0 0 15px 2px rgba($ {indicatorColorFn}, 1); */
  cursor: ${props => (props.title ? 'help' : 'auto')};

  /*
    Animation was nice, but's it's causing whole page to re-pain 
    and so it's super expensive operation.
    See https://web.dev/animations-guide/

    background: rgba($ {indicatorColorFn}, 0.5);
    box-shadow: inset 0 0 10px 2px rgba($ {indicatorColorFn}, 0.5),
      0 0 10px 2px rgba($ {indicatorColorFn}, 0.3);

    animation: $ {props =>
      props.indicatorColor === 'red'
        ? rotateRedAnimation
        : props.indicatorColor === 'yellow'
        ? rotateYellowAnimation
        : rotateGreenAnimation}
    1.5s alternate infinite steps(12);
    
    $ {props =>
    // no animation for gray color
    props.indicatorColor === 'gray' && 'animation: none;'} */
`;

type Props = {
  title?: string;
  color: Colors;
};

function GlowingDot({ color, title }: Props) {
  return <Wrapper title={title} $indicatorColor={color} />;
}

export default GlowingDot;
